import React from 'react'
import {IHrProcessModel} from './HrProcessModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IHrProcessModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onFlow: (process: IHrProcessModel) => void
  onEdit: (process: IHrProcessModel) => void
  onDelete: (process: IHrProcessModel) => void
  loading?: boolean
}

export const HrProcessTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onFlow,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<IHrProcessModel>[] = [
    {key: 'name', label: 'Süreç Adı', className: 'fw-semibold'},
    {
      key: 'flow',
      label: 'Akış',
      width: '140px',
      render: (_, process) => (
        <button
          type='button'
          className='btn btn-sm btn-light-info'
          onClick={() => onFlow(process)}
        >
          <i className='bi bi-diagram-3 fs-5'></i>
          Akış
        </button>
      ),
    },
  ]

  const actions: TableAction<IHrProcessModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz süreç bulunamadı'
    />
  )
}
